export const serverDateFormat = 'YYYY-MM-DDThh:mm:ss.SSSZ';
export const clientDateFormat = 'DD.MM.YYYY';
export const clientDateFullMonthFormat = 'DD MMMM YYYY';
